<div class="flex h-dvh overflow-hidden">
  <p-sidebar-layout>
    <p-sidebar id="preview" collapsible="icon">
      <p-sidebar-spacer />
      <p-sidebar-aside>
        <p-sidebar-panel>
          <p-sidebar-header>
            <p-sidebar-menu>
              <p-sidebar-menu-item>
                <button pSidebarMenuButton class="h-16! p-1!">
                  <img src="./assets/logo.png" />
                  <span class="text-sm font-semibold">{{ title }}</span>
                </button>
              </p-sidebar-menu-item>
            </p-sidebar-menu>
          </p-sidebar-header>
          <p-sidebar-content>
            @if(!userAuthenticated) {
            <p-sidebar-menu>
              <p-sidebar-menu-item>
                <button pSidebarMenuButton (click)="login()">
                  <i class="pi pi-sign-in"></i>
                  <span>Login</span>
                </button>
              </p-sidebar-menu-item>
            </p-sidebar-menu>
            } @else {
              @for (group of menuLinks; track group.label) {
                @if(group.visible) {
                <p-sidebar-group>
                  @if(group.label) {
                  <p-sidebar-group-label>{{ group.label | translate }}</p-sidebar-group-label>
                  }
                  <p-sidebar-group-content>
                    <p-sidebar-menu>
                      @for (item of group.items; track item.label) {
                        @if(item.visible) {
                        <p-sidebar-menu-item>
                          <button pSidebarMenuButton [routerLink]="item.routerLink">
                            <i class="pi" [ngClass]="item.icon"></i>
                            <span>{{ item.label | translate }}</span>
                          </button>
                        </p-sidebar-menu-item>
                        }
                      }
                    </p-sidebar-menu>
                  </p-sidebar-group-content>
                </p-sidebar-group>
                }
              }
            }
          </p-sidebar-content>
          <p-sidebar-footer>
            @if(userAuthenticated) {
            <p-sidebar-menu>
              <p-sidebar-menu-item>
                <button pSidebarMenuButton class="p-1!" [routerLink]="['/currentuser']">
                  <p-avatar [label]="getAvatarCode()" shape="circle" class="size-6 shrink-0 text-xs" />
                  <span> {{ getDisplayName() | translate }}</span>
                </button>
              </p-sidebar-menu-item>
            </p-sidebar-menu>
            }
          </p-sidebar-footer>
          <button pSidebarRail></button>
        </p-sidebar-panel>
      </p-sidebar-aside>
    </p-sidebar>

    <p-sidebar-main>
      <header class="border-surface-200 flex h-12 items-center gap-2 border-b px-4 dark:border-surface-700">
        <button pButton pSidebarTrigger target="preview" severity="secondary" text size="small">
          <i class="pi pi-sidebar"></i>
        </button>
      </header>
      <div class="flex min-h-0 flex-1 flex-col overflow-hidden p-4">
        <router-outlet></router-outlet>
      </div>
    </p-sidebar-main>
  </p-sidebar-layout>
</div>
